class CustomDialog extends HTMLDialogElement {
  constructor() {
    super();
    this.elementId = this.id
    this.openButton = document.querySelector(`[data-custom-dialog-open][aria-controls="${this.id}"]`)
    this.closeButton = this.querySelector('[data-custom-dialog-close]')
  }

  connectedCallback() {
    this.openButton.addEventListener('click', () => {
      this.show();
    })

    this.closeButton.addEventListener('click', () => {
      this.close();
    })
  }
}

if (!customElements.get('custom-dialog')) {
  customElements.define('custom-dialog', CustomDialog, {
    extends: 'dialog',
  });
}
